import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// INTERFACES
import { DevTypeNamesOptionInterface } from "../../../interfaces/AdapterCdoSequent.interface";

export default function FormSelectDevTypeNames({
	inputValue,
	inputOnChange,
}: {
	inputValue: number;
	inputOnChange: (newValue: number) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const { Option } = Select;
	const OPTIONS: DevTypeNamesOptionInterface[] = [
		{ name: "Escalator", value: 0 },
		{ name: "Elevator", value: 1 },
		{ name: "Bot", value: 2 },
		{ name: "Gpio", value: 3 },
		{ name: "Relay", value: 4 },
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='col-md-12 mt-3'>
			<div className='generalStyles__flex'>
				<div className='generalStyles__inputFlexNameLarge'>
					<span className='generalStyles__inputFlexRequired'>*</span>
					<span>Dev type name</span>
				</div>
				<div className='generalStyles__width100'>
					<Select
						className='generalStyles__width100'
						size='small'
						onChange={(e: any) => {
							inputOnChange(e);
						}}
						value={inputValue}
					>
						{OPTIONS.map((item: DevTypeNamesOptionInterface) => (
							<Option key={item.value} value={item.value}>
								{item.name}
							</Option>
						))}
					</Select>
				</div>
				<div className='generalStyles__infoTooltipIconBlank' />
			</div>
		</div>
	);
}
